// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideScan as RawLucideScan } from "lucide-react";
export const LucideScan = /* @__PURE__ */ createIcon(RawLucideScan, "LucideScan", 2);
